import { attr, hasOne } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const MealPreferences = ApplicationRecord.extend({
  attrs: {
    excluded_food_groups: attr(),
    meal_plan: attr(),
    portion_count_per_meal: attr(),
    customer: hasOne({ type: 'customers-customers', persist: false }),
  },
  static: {
    jsonapiType: 'customers-meal_preferences',
  },
});

export default MealPreferences;
